<div class="media-preview-modal">
  <div class="modal-header">
    <div class="file-info">
      <i class="fa-solid" [ngClass]="isImage ? 'fa-image' : (isPdf ? 'fa-file-pdf' : 'fa-file')"></i>
      <span class="file-name">{{ mediaFileName }}</span>
    </div>
    <div class="header-actions">
      <button type="button" class="btn-close-modal" (click)="close()" title="Close">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div *ngIf="isLoading" class="loading-container">
      <i class="fa-solid fa-spinner fa-spin fa-2x"></i>
      <p>Loading preview...</p>
    </div>
    <div *ngIf="loadError && !isLoading" class="error-container">
      <i class="fa-solid fa-exclamation-triangle fa-2x"></i>
      <p>Failed to load preview</p>
      <button type="button" class="btn btn-primary btn-sm" (click)="downloadFile()">
        Download File Instead
      </button>
    </div>
    <div *ngIf="isImage && !isLoading && !loadError && safeMediaUrl" class="image-container">
      <iframe [src]="safeMediaUrl" class="preview-viewer" title="Image Preview"></iframe>
    </div>
    <div *ngIf="isImage && !isLoading && !loadError && !safeMediaUrl && mediaUrl" class="image-container">
      <img [src]="mediaUrl" [alt]="mediaFileName" class="preview-image" (error)="loadError = true" />
    </div>
    <div *ngIf="isPdf && !isLoading && safeMediaUrl" class="pdf-container">
      <iframe [src]="safeMediaUrl" class="pdf-viewer" title="PDF Preview"></iframe>
    </div>
    <div *ngIf="isPdf && !isLoading && !safeMediaUrl && mediaUrl" class="pdf-container">
      <iframe [src]="mediaUrl" class="pdf-viewer" title="PDF Preview"></iframe>
    </div>
    <div *ngIf="!isLoading && !loadError && !isImage && !isPdf && !mediaUrl" class="error-container">
      <p>No media URL provided</p>
    </div>
    <div *ngIf="!isImage && !isPdf && !isLoading && mediaUrl" class="other-file-container">
      <i class="fa-solid fa-file fa-4x"></i>
      <p class="file-name-large">{{ mediaFileName }}</p>
      <p class="file-type">{{ mediaContentType }}</p>
      <button type="button" class="btn btn-primary" (click)="downloadFile()">
        <i class="fa-solid fa-download me-2"></i>
        Download File
      </button>
    </div>
  </div>
</div>
